import React, { useEffect, useState } from 'react';
import { Layout, Spin } from 'antd';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { IWorkingArea } from 'store/ducks/globalTypes';
import { useTranslation } from 'react-i18next';
import { globalOp } from 'store/ducks/Global';
import { useSelector } from 'react-redux';
import { RootState } from 'store/configureStore';
import CardComponent from 'components/CardComponent';
import workingAreas from 'constants/workingAreas';
import TitleBar from 'components/TitleBar';
import * as Styled from './WorkingAreas.styled';

const WorkingAreasPage = () => {
  const { t, i18n } = useTranslation();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const [verifying, setVerifying] = useState(false);

  const { isSuperAdmin, lang } = useSelector(
    (state: RootState) => state.global
  );

  useEffect(() => {
    if (lang) {
      i18n.changeLanguage(lang);
    }
  }, [lang, i18n]);

  useEffect(() => {
    const token = searchParams.get('token');

    if (token) {
      sessionStorage.setItem('user', JSON.stringify({ token }));
      setVerifying(true);

      globalOp
        .verifyLoginToken(token)
        .then(() => {
          setVerifying(false);

          if (isSuperAdmin) {
            navigate('/super_admin', { replace: true });
          } else {
            navigate('/working_area', { replace: true });
          }
        })
        .catch(() => {
          sessionStorage.removeItem('user');
          setVerifying(false);
          navigate('/login');
        });
    }
  }, [searchParams, navigate, isSuperAdmin]);

  const areas = workingAreas(t);

  if (verifying) {
    return (
      <Layout>
        <Styled.LoadingContainer>
          <Spin size='large' />
        </Styled.LoadingContainer>
      </Layout>
    );
  }

  return (
    <Layout>
      <TitleBar title={t('WORKING_AREAS')} />

      <Styled.Container>
        <Styled.GridContainer>
          {areas.map((item: IWorkingArea) => {
            let className = '';

            if (item.href === '/internal_controls') {
              className = 'internal-controls-card';
            } else if (item.href === '/library') {
              className = 'library-card';
            }

            return (
              <CardComponent
                key={item.area}
                area={item.area}
                infoText={item.infoText}
                imgSrc={item.imgSrc}
                href={item.href}
                className={className}
                textOnTop=''
              />
            );
          })}
        </Styled.GridContainer>
      </Styled.Container>
    </Layout>
  );
};

export default WorkingAreasPage;
